import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 8" {...props}>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M.5 1.125v5.75a.75.75 0 0 0 1.136.643l4.792-2.875a.75.75 0 0 0 0-1.286L1.636.482A.75.75 0 0 0 .5 1.125Z"
    />
  </svg>
);
export const PlaySmallIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
